import { type CoverageRow } from '@apps/web/features/coverage/model/coverage_types';

export type CoverageArea = 'office' | 'city' | 'zip';

export type AreaValue = {
    readonly key: string;
    readonly label: string;
};

export const MISSING_AREA_KEY = '\u0000missing';
export const MISSING_AREA_LABEL = 'Unknown';

export function normalizeAreaValue(raw: string | null | undefined): AreaValue {
    const value = raw?.trim();
    if (!value) {
        return { key: MISSING_AREA_KEY, label: MISSING_AREA_LABEL };
    }
    return {
        key: value,
        label: value === MISSING_AREA_LABEL ? 'Unknown (entered value)' : value,
    };
}

export function areaValueForRow(
    row: CoverageRow,
    area: CoverageArea,
): AreaValue {
    if (area === 'office') {
        return normalizeAreaValue(row.office_name);
    }
    if (area === 'city') {
        return normalizeAreaValue(row.city);
    }
    return normalizeAreaValue(row.postal_code?.trim().slice(0, 5));
}
